export const LEAD_STAGES = ["da_valutare", "primo_contatto", "appuntamento_fissato", "appuntamento_svolto", "preventivo_inviato"];

export const STAGE_META = {
  da_valutare: { label: "Da valutare", color: "#94a3b8" },
  primo_contatto: { label: "Primo contatto", color: "#c8a35b" },
  appuntamento_fissato: { label: "Appuntamento fissato", color: "#5b8def" },
  appuntamento_svolto: { label: "Appuntamento svolto", color: "#8b5cf6" },
  preventivo_inviato: { label: "Preventivo inviato", color: "#f59e0b" },
  vinto: { label: "Diventato cliente", color: "#22a35a" },
  perso: { label: "Non ha accettato", color: "#c46b66" },
};

const LEGACY = { mezzora_richiesta: "primo_contatto", mezzora_fissata: "appuntamento_fissato", proposta: "preventivo_inviato" };
export const normStage = (s) => LEGACY[s] || s;

export function StageBadge({ stage }) {
  const s = normStage(stage);
  const m = STAGE_META[s] || { label: s, color: "#64748b" };
  return (
    <span className="pill" style={{ background: m.color + "26", color: m.color, border: `1px solid ${m.color}66` }}>
      {m.label}
    </span>
  );
}
